module.exports = __webpack_public_path__ + "img/color-drop_cn.2834503.jpg";